import React from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Service } from '@/types/serviceTypes';

interface ServiceCardProps {
  service: Service;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ service }) => {
  return (
    <Card key={service.id} id={service.id} className="overflow-hidden hover:shadow-lg transition-shadow duration-300 scroll-mt-40 h-full flex flex-col">
      <div className="aspect-video overflow-hidden">
        <img 
          src={service.image} 
          alt={service.title} 
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
          onError={(e) => {
            e.currentTarget.src = "https://images.unsplash.com/photo-1485683761c6c5981b2b970602604d51?q=80&w=2069&auto=format&fit=crop";
            console.error(`Image for ${service.title} failed to load`);
          }}
        />
      </div>
      <CardHeader>
        <CardTitle className="text-2xl font-serif text-pkstone-900">{service.title}</CardTitle>
        <CardDescription className="text-pkstone-600">{service.description}</CardDescription>
      </CardHeader>
      <CardContent className="flex-grow">
        <ul className="space-y-2">
          {service.features.map((feature, index) => (
            <li key={index} className="flex items-start">
              <Check className="h-5 w-5 text-pkgreen-500 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-pkstone-700">{feature}</span>
            </li>
          ))}
        </ul>
      </CardContent>
      <CardFooter className="border-t pt-4">
        <Button asChild variant="outline" className="w-full border-pkgreen-600 text-pkgreen-600 hover:bg-pkgreen-50">
          <Link to={`/services/${service.id}`}>
            Learn More
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </CardFooter>
    </Card>
  );
};

export default ServiceCard;
